export enum PropertyKeys {
    PAGE_SIZE = 'meinestadt/resultlist#pageSize',
    SR = 'meinestadt/realEstate#area',
    ESR = 'meinestadt/realEstate#mietenKaufen',
    ETYPE = 'meinestadt/realEstate#estateTypes',
    ETYPE_COMMERCIAL = 'meinestadt/realEstate#estateTypesCommercial',
    ECAT = 'meinestadt/realEstate#estateCategories',
    EQID = 'meinestadt/realEstate#equipmentIds',
    ROOMI = 'meinestadt/realEstate#minRooms',
    ROOMA = 'meinestadt/realEstate#maxRooms',
    PRIMI = 'meinestadt/realEstate#minPrice',
    PRIMA = 'meinestadt/realEstate#maxPrice',
    FLMI = 'meinestadt/realEstate#minLivingArea',
    FLMA = 'meinestadt/realEstate#maxLivingArea',
    AFFILIATE_ID = 'meinestadt/types#searchbox_bookingAid',
    SORT = 'meinestadt/realEstate#sorting',
    FILTER_TAG = 'meinestadt/realEstate#searchBoxFilterTag',
}

export enum SearchRequestKeys {
    PAGE_SIZE = 'pageSize',
    SEARCH_RADIUS = 'sr',
    ESTATE_SELL_RENT = 'esr',
    ESTATE_TYPE = 'etype',
    ESTATE_CATEGORY = 'ecat',
    EQUIPMENT_ID = 'eqid',
    ESTATE_POSITION = 'epos',
    FURNISHING_ID = 'furnid',
    ROOM_MIN = 'roomi',
    ROOM_MAX = 'rooma',
    PRICE_MIN = 'primi',
    PRICE_MAX = 'prima',
    FLOOR_MIN = 'flmi',
    FLOOR_MAX = 'flma',
    AFFILIATE_ID = 'affiliateId',
    SORT = 'sort',
    FILTER_TAG = 'filterTag',
    LATITUDE = 'lat',
    LONGITUDE = 'lng',
    LOCATION = 'location',
}

export enum SearchBoxFilterTag {
    CMS_NAME = 'Gewerbe',
    REQUEST_KEY = 'industry',
}
